const Icon = (props) => {
  return (
    <img
      className={`h-10 w-10 flex-shrink-0 rounded-full bg-gray-300 ${props.className}`}
      src={props.imageUrl}
      alt={props.alt}
    />
  );
};

export default Icon;
